import errorMessages from '../const/joiErrorMessages';

const Joi = require('joi-browser');
const joiToForms = require('joi-errors-for-forms').form;
const convertToForms = joiToForms(errorMessages);

export const validateFormValuesUsingJoiSchema = (values, joiSchema) => {
  const joiResult = Joi.validate(values, joiSchema, {
    convert: true,
    abortEarly: false,
    stripUnknown: true,
  });
  if (!joiResult.error) {
    return {};
  }
  return convertToForms(joiResult.error);
};

export const validatePhoneNumber = value => {
  return /^(62|0){0,1}([87]\d{7,11})$/.test(value);
};
